if (!customElements.get('artist-hover-links')) {
  class ArtistHoverLinks extends HTMLElement {
    constructor() {
      super();
      this.card = null;
      this.cardImg = null;
      this.links = [];
      this.isVisible = false;
      this.mouseX = 0;
      this.mouseY = 0;
      this.rafId = null;

      this.positionCard = this.positionCard.bind(this);
      this.onMouseEnter = this.onMouseEnter.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
    }

    connectedCallback() {
      var self = this;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          self.init();
        });
      } else {
        setTimeout(function () {
          self.init();
        }, 0);
      }
    }

    init() {
      var sectionId = this.dataset.sectionId;
      if (!sectionId) return;

      this.card = this.querySelector('.artist-hover__card') || document.querySelector('.artist-hover__card');
      if (!this.card) return;

      this.cardImg = this.card.querySelector('img');
      this.links = this.querySelectorAll('.artist-hover__link');
      this.isMobile = window.innerWidth <= 749 || ('ontouchstart' in window);
      this.activeLink = null;

      this.onResize = this.onResize.bind(this);
      this.onTap = this.onTap.bind(this);
      this.onDocumentTap = this.onDocumentTap.bind(this);

      window.addEventListener('resize', this.onResize);

      if (this.isMobile) {
        this.bindMobile();
      } else {
        this.bindDesktop();
      }

      /* On touch devices wider than 749px, also bind tap so card works on tablets */
      if ('ontouchstart' in window && !this.isMobile) {
        this.bindMobile();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.unbindDesktop();
      this.unbindMobile();

      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }

    onResize() {
      var wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 749 || ('ontouchstart' in window);
      if (wasMobile !== this.isMobile) {
        this.hideCard();
        if (this.isMobile) {
          this.unbindDesktop();
          this.bindMobile();
        } else {
          this.unbindMobile();
          this.bindDesktop();
        }
      }
    }

    bindDesktop() {
      this.links.forEach(function (link) {
        link.addEventListener('mouseenter', this.onMouseEnter);
        link.addEventListener('mouseleave', this.onMouseLeave);
        link.addEventListener('mousemove', this.onMouseMove);
      }.bind(this));
    }

    unbindDesktop() {
      this.links.forEach(function (link) {
        link.removeEventListener('mouseenter', this.onMouseEnter);
        link.removeEventListener('mouseleave', this.onMouseLeave);
        link.removeEventListener('mousemove', this.onMouseMove);
      }.bind(this));
    }

    bindMobile() {
      this.links.forEach(function (link) {
        link.addEventListener('click', this.onTap);
      }.bind(this));
      document.addEventListener('click', this.onDocumentTap);
    }

    unbindMobile() {
      this.links.forEach(function (link) {
        link.removeEventListener('click', this.onTap);
      }.bind(this));
      document.removeEventListener('click', this.onDocumentTap);
    }

    onTap(e) {
      e.preventDefault();
      var link = e.currentTarget;

      /* If tapping the same artist again, navigate to collection */
      if (this.activeLink === link) {
        window.location.href = link.getAttribute('href');
        return;
      }

      var imgSrc = link.getAttribute('data-hover-img');
      var altText = link.textContent.trim();
      this.activeLink = link;

      if (imgSrc) {
        this.cardImg.src = imgSrc;
        this.cardImg.alt = altText || '';
        this.card.href = link.getAttribute('href');
        this.card.classList.add('is-visible');
      }
    }

    onDocumentTap(e) {
      if (!this.activeLink) return;
      if (e.target.closest('.artist-hover__link') || e.target.closest('.artist-hover__card')) return;
      this.hideCard();
      this.activeLink = null;
    }

    onMouseEnter(e) {
      var imgSrc = e.currentTarget.getAttribute('data-hover-img');
      var altText = e.currentTarget.textContent.trim();
      this.showCard(imgSrc, altText);
    }

    onMouseLeave() {
      this.hideCard();
    }

    onMouseMove(e) {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    }

    positionCard() {
      if (!this.isVisible) return;

      var cardW = this.card.offsetWidth;
      var cardH = this.card.offsetHeight;
      var offset = 20;
      var winW = window.innerWidth;
      var winH = window.innerHeight;

      var x = this.mouseX + offset;
      var y = this.mouseY - cardH / 2;

      if (x + cardW > winW - 10) {
        x = this.mouseX - cardW - offset;
      }
      if (y < 10) {
        y = 10;
      }
      if (y + cardH > winH - 10) {
        y = winH - cardH - 10;
      }

      this.card.style.left = x + 'px';
      this.card.style.top = y + 'px';

      this.rafId = requestAnimationFrame(this.positionCard);
    }

    showCard(imgSrc, altText) {
      if (!imgSrc || window.innerWidth <= 749) return;
      this.cardImg.src = imgSrc;
      this.cardImg.alt = altText || '';
      this.isVisible = true;
      this.card.classList.add('is-visible');
      this.rafId = requestAnimationFrame(this.positionCard);
    }

    hideCard() {
      this.isVisible = false;
      this.card.classList.remove('is-visible');
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    }
  }

  customElements.define('artist-hover-links', ArtistHoverLinks);
}
